import { map, find, isNil, filter, orderBy } from "lodash";

import { COMPETITIVE_COLORS } from "api/Teams";

const TOP_COLOR = "#52C5CD";
const BOTTOM_COLOR = "#FF5252";

export const getInstructorsDashboardPerformanceColors = count => {
  let result = ["top", "top", "bottom", "bottom"].slice(0, count);

  for (let i = 0, length = count - 4; i < length; i++) {
    result.push(i % 2 === 0 ? "top" : "bottom");
  }

  result.sort((a, b) => {
    if (a === b) {
      return 0;
    }

    if (a === "top" && b === "bottom") {
      return -1;
    }

    return 1;
  });

  return result.map(i => (i === "top" ? TOP_COLOR : BOTTOM_COLOR));
};

export const getPerformanceValues = values => {
  let entities = orderBy(values, ["value"], ["desc"]);
  let result = [];

  if (entities.length > 0) {
    result.push(entities.shift());
  }

  if (entities.length > 0) {
    result.push(entities.shift());
  }

  if (entities.length > 0) {
    result.push(entities.pop());
  }

  if (entities.length > 0) {
    result.push(entities.pop());
  }

  let isTop = true;
  while (entities.length > 0) {
    if (isTop === true) {
      result.push(entities.shift());
      isTop = false;
    } else {
      result.push(entities.pop());
      isTop = true;
    }
  }

  result = orderBy(result, ["value"], ["desc"]);
  if (result.length > 10) {
    result = [...result.slice(0, 5), ...result.slice(-5)];
  }

  return result;
};

export const getTeam = (teamId, competitiveAnalysis) =>
  find(competitiveAnalysis, team => team["team"] === teamId) || {};

export const pickValue = (teams, metrics, field, key = "name") =>
  map(metrics, metric => ({
    id: (find(teams, team => team.id === metric.team) || {}).id,
    [key]: (find(teams, team => team.id === metric.team) || {}).name,
    value: metric && metric[field] ? metric[field] : 0
  }));

export const pickPercent = (teams, metrics, field) =>
  map(pickValue(teams, metrics, field), metric => ({
    ...metric,
    value: metric.value * 100
  }));

export const pickMillions = (teams, metrics, field) =>
  map(pickValue(teams, metrics, field), metric => ({
    ...metric,
    value: metric.value / 1e6
  }));

export const teamColor = (teams, teamId) => {
  const idx = teams.findIndex(i => i.id === teamId);

  return COMPETITIVE_COLORS[idx % COMPETITIVE_COLORS.length];
};

export const teamColors = (teams, data) =>
  map(data, row => teamColor(teams, row.team));

export const getField = (field, fieldMatch, products, id) => {
  const product = find(products, product => product[fieldMatch] === id);
  if (isNil(product)) {
    return id;
  }

  return product[field];
};

export const getCompetitionTeams = (teams, teamId) => {
  const myTeam = find(teams, team => team.id === teamId);
  return filter(teams, team => team.competition === myTeam.competition);
};



// WEBPACK FOOTER //
// ./src/components/analysis/utils.js